import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useAuth } from '@src/hooks/useAuth';
import { FeedbackWidgetBase } from './FeedbackWidgetBase';
/**
 * A widget to provide users an option to share their
 * feedback via Guild's UserVoice tool.
 */
export const FeedbackWidget = (props) => {
    const [loaded, setLoaded] = useState(false);
    const { currentUser } = useAuth();
    useEffect(() => {
        let uv;
        const exists = document.getElementById('guildFeedbackWidgetScript');
        if (!exists) {
            uv = document.createElement('script');
            uv.type = 'text/javascript';
            uv.async = true;
            uv.id = 'guildFeedbackWidgetScript';
            uv.onload = () => {
                setLoaded(true);
            };
            uv.src =
                '//guildeducation.uservoice.com/widget_environment/ypt0RbkEXUEMPjlrgBlWg.js';
            document.body.appendChild(uv);
        }
        else {
            setLoaded(true);
        }
        return () => {
            if (uv) {
                uv.onload = null;
            }
        };
    }, []); // Empty dependency array - only run once
    if (!currentUser) {
        return null;
    }
    const feedbackUser = {
        id: String(currentUser.id),
        clientName: currentUser.clientInfo?.name,
        clientId: String(currentUser.clientId),
        email: currentUser.email,
    };
    if (loaded) {
        return _jsx(FeedbackWidgetBase, { ...props, user: feedbackUser });
    }
    return null;
};
export default FeedbackWidget;
